import { render } from "./editUserInfo.vue?vue&type=template&id=48f942ee&scoped=true"
import script from "./editUserInfo.vue?vue&type=script&lang=js"
export * from "./editUserInfo.vue?vue&type=script&lang=js"

import "./editUserInfo.vue?vue&type=style&index=0&id=48f942ee&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48f942ee"]])

export default __exports__